import { Paper, Stack, Title } from "@mantine/core";
import { useLocalStorage } from "@mantine/hooks";
import dayjs from "dayjs";

import { TextSerif } from "@/components/elements";
import { defaultCurrency } from "@/lib/currency";
import { formatCurrency } from "@/utils/formatEuro";

import type { Currency } from "@/types/currency";
import type { FC } from "react";

export type CarTransactionsTooltipProps = {
  payload?: Record<string, any>[];
};

const order = ["value", "date"];

export const CarTransactionsTooltip: FC<CarTransactionsTooltipProps> = ({ payload }) => {
  const [currency] = useLocalStorage<Currency>({
    key: "currency",
    defaultValue: defaultCurrency,
  });

  if (!payload) {
    return null;
  }

  const sortedPayload = payload.sort((a, b) => order.indexOf(a.name) - order.indexOf(b.name));

  function renderItem(item: Record<string, any>) {
    switch (item.name) {
      case "value":
        return (
          <Title order={5}>
            {formatCurrency(item.value, currency.code, { notation: "standard" })}
          </Title>
        );
      case "date":
        return (
          <TextSerif size="sm">{dayjs.unix(item.value).format("MMM DD, YYYY") || "-"}</TextSerif>
        );
      default:
        return null;
    }
  }

  return (
    <Paper px="md" py="sm" withBorder shadow="md">
      <Stack gap="xs">{sortedPayload.map((item) => renderItem(item))}</Stack>
    </Paper>
  );
};
